import { forwardRef } from "react";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CalendarIcon = forwardRef<HTMLDivElement>((props, ref) => (
    <div ref={ref} {...props}>
        <FontAwesomeIcon className="fa" icon={faCalendarDays} />
    </div>
));

export default CalendarIcon;
